import { getAPIGETResponse } from './BaseService';

const baseUrl = process.env.REACT_APP_USERS_API_BASE_URL;

export async function GetUser() {
        return await getAPIGETResponse(baseUrl, 'getuser', true);
}